<template>
	<div>
		<center style="background-color:#FFFFFF;">
			<table border="0" cellpadding="0" cellspacing="0" height="100%" width="100%" id="bodyTable"
				style="table-layout: fixed;max-width:100% !important;width: 100% !important;min-width: 100% !important;">
				<tr>
					<td align="center" valign="top" id="bodyCell">
						<!-- EMAIL HEADER // -->
						<!--
	The table "emailBody" is the email's container.
	Its width can be set to 100% for a color band that spans the width of the page.	-->
						
						<!-- // END -->
						<!-- EMAIL BODY // -->
						<!--
	The table "emailBody" is the email's container.
	Its width can be set to 100% for a color band
	that spans the width of the page.
	-->
						<table bgcolor="#FFFFFF" border="0" cellpadding="0" cellspacing="0" width="640" id="emailBody">

							<!-- SECTION #1 -->
							<tr>
								<td align="center" valign="top">
									<!-- CENTERING TABLE // -->
									<table border="0" cellpadding="0" cellspacing="0" width="100%"
										style="color:#FFFFFF;" bgcolor="#FFFFFF">
										<tr>
											<td align="center" valign="top">
												<!-- FLEXIBLE CONTAINER // -->
												<table border="0" cellpadding="0" cellspacing="0" width="640"
													class="flexibleContainer">
													<tr>
														<td align="center" valign="top" width="640"
															class="flexibleContainerCell">
															<!-- CONTENT TABLE // -->
															<table width="100%" height="" border="0" cellpadding="0"
																cellspacing="0" background="">
																<tr>
																	<td align="center" valign="top" class="textContent">
																		<img src="/static/commercial/loginbanner/img-sec-10.jpg"
																			alt="" width="640" height="399" style="max-width:640px;width:100%;display:block;"
																			usemap="#Map" /></td>
																</tr>
															</table><!-- // CONTENT TABLE -->
														</td>
													</tr>
												</table>
												<!-- // FLEXIBLE CONTAINER -->
											</td>
										</tr>
									</table>
									<!-- // CENTERING TABLE -->
								</td>
							</tr>
							<!-- CLOSE SECTION #1 -->

							<!-- SECTION #2 -->
							<tr>
								<td align="center" valign="top">
									<!-- CENTERING TABLE // -->
									<table border="0" cellpadding="0" cellspacing="0" width="100%"
										style="color:#FFFFFF;" bgcolor="#FFFFFF">
										<tr>
											<td align="center" valign="top">
												<!-- FLEXIBLE CONTAINER // -->
												<table border="0" cellpadding="0" cellspacing="0" width="640"
													class="flexibleContainer">
													<tr>
														<td align="center" valign="top" width="640"
															class="flexibleContainerCell">
															<!-- CONTENT TABLE // -->
															<table width="100%" height="" border="0" cellpadding="0"
																cellspacing="0" background="">
																<tr>
																	<td align="center" valign="top" class="textContent">
																		<img src="/static/commercial/loginbanner/img-sec-11.jpg"
																			alt="" width="640" height="333"
																			class="flexibleImage"
																			style="max-width:640px;width:100%;display:block;"
																			title="" /></td>
																</tr>
															</table><!-- // CONTENT TABLE -->
														</td>
													</tr>
												</table>
												<!-- // FLEXIBLE CONTAINER -->
											</td>
										</tr>
									</table>
									<!-- // CENTERING TABLE -->
								</td>
							</tr>
							<!-- CLOSE SECTION #2 -->
							<!-- SECTION #2 -->
							<tr>
								<td align="center" valign="top">
									<!-- CENTERING TABLE // -->
									<table border="0" cellpadding="0" cellspacing="0" width="100%"
										style="color:#FFFFFF;" bgcolor="#FFFFFF">
										<tr>
											<td align="center" valign="top">
												<!-- FLEXIBLE CONTAINER // -->
												<table border="0" cellpadding="0" cellspacing="0" width="640"
													class="flexibleContainer">
													<tr>
														<td align="center" valign="top" width="640"
															class="flexibleContainerCell">
															<!-- CONTENT TABLE // -->
															<!-- // CONTENT TABLE -->
														</td>
													</tr>
												</table>
												<!-- // FLEXIBLE CONTAINER -->
											</td>
										</tr>
									</table>
									<!-- // CENTERING TABLE -->
								</td>
							</tr>
							<!-- CLOSE SECTION #2 -->

							<!-- SECTION #3 -->
							<tr>
								<td align="center" valign="top">
									<!-- CENTERING TABLE // -->
									<table border="0" cellpadding="0" cellspacing="0" width="100%"
										style="color:#FFFFFF;" bgcolor="#FFFFFF">
										<tr>
											<td align="center" valign="top">
												<!-- FLEXIBLE CONTAINER // -->
												<table border="0" cellpadding="0" cellspacing="0" width="640"
													class="flexibleContainer">
													<tr>
														<td align="center" valign="top" width="640"
															class="flexibleContainerCell">
															<!-- CONTENT TABLE // -->
															<!-- // CONTENT TABLE -->
														</td>
													</tr>
												</table>
												<!-- // FLEXIBLE CONTAINER -->
											</td>
										</tr>
									</table>
									<!-- // CENTERING TABLE -->
								</td>
							</tr>
							<!-- CLOSE SECTION #3 - IG-->
							<!-- SECTION #3 -->
							<tr>
								<td align="center" valign="top">
									<!-- CENTERING TABLE // -->
									<table border="0" cellpadding="0" cellspacing="0" width="100%"
										style="color:#FFFFFF;" bgcolor="#FFFFFF">
										<tr>
											<td align="center" valign="top">
												<!-- FLEXIBLE CONTAINER // -->
												<table border="0" cellpadding="0" cellspacing="0" width="640"
													class="flexibleContainer">
													<tr>
														<td align="center" valign="top" width="640"
															class="flexibleContainerCell">
															<!-- CONTENT TABLE // -->
															<!-- // CONTENT TABLE -->
														</td>
													</tr>
												</table>
												<!-- // FLEXIBLE CONTAINER -->
											</td>
										</tr>
									</table>
									<!-- // CENTERING TABLE -->
								</td>
							</tr>
							<!-- CLOSE SECTION #3 - IG -->

							<!-- SECTION #3 -->
							<tr>
								<td align="center" valign="top">
									<!-- CENTERING TABLE // -->
									<table border="0" cellpadding="0" cellspacing="0" width="100%"
										style="color:#FFFFFF;" bgcolor="#FFFFFF">
										<tr>
											<td align="center" valign="top">
												<!-- FLEXIBLE CONTAINER // -->
												<table border="0" cellpadding="0" cellspacing="0" width="640"
													class="flexibleContainer">
													<tr>
														<td align="center" valign="top" width="640"
															class="flexibleContainerCell">
															<!-- CONTENT TABLE // -->
															<table width="100%" height="" border="0" cellpadding="0"
																cellspacing="0" background="">
																<tr>
																	<td align="center" valign="top" class="textContent">
																		<img src="/static/commercial/loginbanner/img-sec-12.jpg"
																			width="640" class="flexibleImage"
																			style="max-width:640px;width:100%;display:block;"
																			alt="www.eremit.com.my"
																			title="www.eremit.com.my" /></td>
																</tr>
															</table><!-- // CONTENT TABLE -->
														</td>
													</tr>
												</table>
												<!-- // FLEXIBLE CONTAINER -->
											</td>
										</tr>
									</table>
									<!-- // CENTERING TABLE -->
								</td>
							</tr>
							<!-- CLOSE SECTION #3 -->


							<!-- SECTION - SPACE -->
							<tr>
								<td align="center" valign="top">
									<!-- CENTERING TABLE // -->
									<table border="0" cellpadding="0" cellspacing="0" width="100%"
										style="color:#FFFFFF;" bgcolor="#FFFFFF">
										<tr>
											<td align="center" valign="top">
												<!-- FLEXIBLE CONTAINER // -->
												<table border="0" cellpadding="0" cellspacing="0" width="640"
													class="flexibleContainer">
													<tr>
														<td align="center" valign="top" width="640"
															class="flexibleContainerCell">
															<!-- CONTENT TABLE // -->
															<table width="100%" height="" border="0" cellpadding="0"
																cellspacing="0" background="">
																<tr>
																	<td align="center" valign="top" class="textContent">
																		&nbsp;</td>
																</tr>
															</table><!-- // CONTENT TABLE -->
														</td>
													</tr>
												</table>
												<!-- // FLEXIBLE CONTAINER -->
											</td>
										</tr>
									</table>
									<!-- // CENTERING TABLE -->
								</td>
							</tr>
							<!-- CLOSE SECTION - SPACE -->

						</table>

						<!-- // END -->

					</td>
				</tr>
			</table>
		</center>

		<map name="Map" id="Map">
			<area shape="rect" coords="359,52,490,97"
				href="https://play.google.com/store/apps/details?id=com.app.mtaeremit&amp;hl=en" target="_blank"
				alt="eRemit Google Playstore" />
			<area shape="rect" coords="494,53,620,100" href="https://apps.apple.com/my/app/e-remit/id1060407677"
				target="_blank" alt="eRemit App Store" />
		</map>
	</div>

</template>





<script>
	export default {

	}
</script>


<style scoped>
	/* RESET STYLES */
	html {
		background-color: #FFFFFF;
		margin: 0;
		padding: 0;
	}

	body,
	#bodyTable,
	#bodyCell,
	#bodyCell {
		height: 100% !important;
		margin: 0;
		padding: 0;
		width: 100% !important;
		font-family: 'Montserrat', sans-serif;
	}

	table {
		border-collapse: collapse;
	}

	table[id=bodyTable] {
		width: 100% !important;
		margin: auto;
		max-width: 640px !important;
		color: #7A7A7A;
		font-weight: normal;
	}

	img,
	a img {
		border: 0;
		outline: none;
		text-decoration: none;
		height: auto;
		line-height: 100%;
	}

	a {
		text-decoration: none !important;
		border-bottom: 1px solid;
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		color: #5F5F5F;
		font-weight: normal;
		font-family: 'Montserrat', sans-serif;
		font-size: 20px;
		line-height: 125%;
		text-align: Left;
		letter-spacing: normal;
		margin-top: 0;
		margin-right: 0;
		margin-bottom: 10px;
		margin-left: 0;
		padding-top: 0;
		padding-bottom: 0;
		padding-left: 0;
		padding-right: 0;
	}

	/* CLIENT-SPECIFIC STYLES */
	.ReadMsgBody {
		width: 100%;
	}

	.ExternalClass {
		width: 100%;
	}

	/* Force Hotmail/Outlook.com to display emails at full width. */
	.ExternalClass,
	.ExternalClass p,
	.ExternalClass span,
	.ExternalClass font,
	.ExternalClass td,
	.ExternalClass div {
		line-height: 100%;
	}

	/* Force Hotmail/Outlook.com to display line heights normally. */
	table,
	td {
		mso-table-lspace: 0pt;
		mso-table-rspace: 0pt;
	}

	/* Remove spacing between tables in Outlook 2007 and up. */
	#outlook a {
		padding: 0;
	}

	/* Force Outlook 2007 and up to provide a "view in browser" message. */
	img {
		-ms-interpolation-mode: bicubic;
		display: block;
		outline: none;
		text-decoration: none;
	}

	/* Force IE to smoothly render resized images. */
	body,
	table,
	td,
	p,
	a,
	li,
	blockquote {
		-ms-text-size-adjust: 100%;
		-webkit-text-size-adjust: 100%;
		font-weight: normal !important;
	}

	/* Prevent Windows- and Webkit-based mobile platforms from changing declared text sizes. */
	.ExternalClass td[class="ecxflexibleContainerBox"] h3 {
		padding-top: 10px !important;
	}

	/* Force hotmail to push 2-grid sub headers down */

	/* /\/\/\/\/\/\/\/\/ TEMPLATE STYLES /\/\/\/\/\/\/\/\/ */

	/* ========== Page Styles ========== */
	h1 {
		display: block;
		font-size: 26px;
		font-style: normal;
		font-weight: normal;
		line-height: 100%;
	}

	h2 {
		display: block;
		font-size: 20px;
		font-style: normal;
		font-weight: normal;
		line-height: 120%;
	}

	h3 {
		display: block;
		font-size: 17px;
		font-style: normal;
		font-weight: normal;
		line-height: 110%;
	}

	h4 {
		display: block;
		font-size: 18px;
		font-style: italic;
		font-weight: normal;
		line-height: 100%;
	}

	.flexibleImage {
		height: auto;
	}

	.linkRemoveBorder {
		border-bottom: 0 !important;
	}

	table[class=flexibleContainerCellDivider] {
		padding-bottom: 0 !important;
		padding-top: 0 !important;
	}

	body,
	#bodyTable {
		background-color: #FFFFFF;
	}

	#emailHeader {
		background-color: #FFFFFF;
	}

	#emailBody {
		background-color: #FFFFFF;
	}

	#emailFooter {
		background-color: #FFFFFF;
	}

	.nestedContainer {
		background-color: #F8F8F8;
		border: 1px solid #CCCCCC;
	}

	.emailButton {
		background-color: #205478;
		border-collapse: separate;
	}

	.buttonContent {
		color: #FFFFFF;
		font-family: 'Montserrat', sans-serif;
		font-size: 18px;
		font-weight: bold;
		line-height: 100%;
		padding: 15px;
		text-align: center;
	}

	.buttonContent a {
		color: #FFFFFF;
		display: block;
		text-decoration: none !important;
		border: 0 !important;
	}

	.emailCalendar {
		background-color: #FFFFFF;
		border: 1px solid #CCCCCC;
	}

	.emailCalendarMonth {
		background-color: #205478;
		color: #FFFFFF;
		font-family: 'Montserrat', sans-serif;
		font-size: 16px;
		font-weight: bold;
		padding-top: 10px;
		padding-bottom: 10px;
		text-align: center;
	}

	.emailCalendarDay {
		color: #205478;
		font-family: 'Montserrat', sans-serif;
		font-size: 60px;
		font-weight: bold;
		line-height: 100%;
		padding-top: 20px;
		padding-bottom: 20px;
		text-align: center;
	}

	.imageContentText {
		margin-top: 10px;
		line-height: 0;
	}

	.imageContentText a {
		line-height: 0;
	}

	#invisibleIntroduction {
		display: none !important;
	}

	/* Removing the introduction text from the view */

	/*FRAMEWORK HACKS & OVERRIDES */
	span[class=ios-color-hack] a {
		color: #275100 !important;
		text-decoration: none !important;
	}

	/* Remove all link colors in IOS (below are duplicates based on the color preference) */
	span[class=ios-color-hack2] a {
		color: #205478 !important;
		text-decoration: none !important;
	}

	span[class=ios-color-hack3] a {
		color: #8B8B8B !important;
		text-decoration: none !important;
	}

	/* A nice and clean way to target phone numbers you want clickable and avoid a mobile phone from linking other numbers that look like, but are not phone numbers.  Use these two blocks of code to "unstyle" any numbers that may be linked.  The second block gives you a class to apply with a span tag to the numbers you would like linked and styled.
	Inspired by Campaign Monitor's article on using phone numbers in email: http://www.campaignmonitor.com/blog/post/3571/using-phone-numbers-in-html-email/.
	*/
	.a[href^="tel"],
	a[href^="sms"] {
		text-decoration: none !important;
		color: #606060 !important;
		pointer-events: none !important;
		cursor: default !important;
	}

	.mobile_link a[href^="tel"],
	.mobile_link a[href^="sms"] {
		text-decoration: none !important;
		color: #606060 !important;
		pointer-events: auto !important;
		cursor: default !important;
	}


	/* MOBILE STYLES */
	@media only screen and (max-width: 480px) {

		/*////// CLIENT-SPECIFIC STYLES //////*/
		body {
			width: 100% !important;
			min-width: 100% !important;
		}

		/* Force iOS Mail to render the email at full width. */
		/* FRAMEWORK STYLES */
		/*
	CSS selectors are written in attribute selector format to prevent Yahoo Mail from rendering media query styles on desktop.
	*/
		/*td[class="textContent"], td[class="flexibleContainerCell"] { width: 100%; padding-left: 10px !important; padding-right: 10px !important; }*/
		table[id="emailHeader"],
		table[id="emailBody"],
		table[id="emailFooter"],
		table[class="flexibleContainer"],
		td[class="flexibleContainerCell"] {
			width: 100% !important;
		}

		td[class="flexibleContainerBox"],
		td[class="flexibleContainerBox"] table {
			display: block;
			width: 100%;
			text-align: left;
		}

		/*
	The following style rule makes any image classed with 'flexibleImage' fluid when the query activates. Make sure you add an inline max-width to those images to prevent them from blowing out.
	*/
		td[class="imageContent"] img {
			height: auto !important;
			width: 100% !important;
			max-width: 100% !important;
		}

		img[class="flexibleImage"] {
			height: auto !important;
			width: 100% !important;
			max-width: 100% !important;
		}

		img[class="flexibleImageSmall"] {
			height: auto !important;
			width: auto !important;
		}

		/* Create top space for every second element in a block */
		table[class="flexibleContainerBoxNext"] {
			padding-top: 10px !important;
		}

		/* Make buttons in the email span the full width of their container, allowing for left- or right-handed ease of use.*/
		table[class="emailButton"] {
			width: 100% !important;
		}

		td[class="buttonContent"] {
			padding: 0 !important;
		}

		td[class="buttonContent"] a {
			padding: 15px !important;
		}

	}

	/*  CONDITIONS FOR ANDROID DEVICES ONLY
	*   http://developer.android.com/guide/webapps/targeting.html
	*   http://pugetworks.com/2011/04/css-media-queries-for-targeting-different-mobile-devices/ ;
	=====================================================*/

	@media only screen and (-webkit-device-pixel-ratio:.75) {
		/* Put CSS for low density (ldpi) Android layouts in here */
	}

	@media only screen and (-webkit-device-pixel-ratio:1) {
		/* Put CSS for medium density (mdpi) Android layouts in here */
	}

	@media only screen and (-webkit-device-pixel-ratio:1.5) {
		/* Put CSS for high density (hdpi) Android layouts in here */
	}

	/* end Android targeting */

	/* CONDITIONS FOR IOS DEVICES ONLY
	=====================================================*/
	@media only screen and (min-device-width : 320px) and (max-device-width:568px) {}

	/* end IOS targeting */
</style>
